import {
  Autocomplete,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,

} from "@mui/material";
import {React, useState} from "react";
// import { useTranslation } from "react-i18next";
// import {
//   setDatePickerFrom,
//   setDatePickerTo,
//   clearDates
// } from "../../reducers/MapSlice";
// import CustomYearsPicker from "../Prediction/CustomYearPicker";
// import MonthDayRangePicker from "../Prediction/MonthDayRangePicker";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOneAddIndex,
  setAddedIndexesFilterToggle,
  setAddedIndexesInit,
  setAddedIndexesId,
  setAddedIndexesName,
  setAddedIndexesOrder,
  setAddedIndexesPeriodOfTime,
  setAddedIndexesShortTerm,
  setAddedIndexesSummerizeOptions,
  setAddedIndexesTemporalMethod,
  setAddedIndexesWindow,
  setAddedIndexesYearFrom,
  setAddedIndexesYearTo,
  // setAddedIndexesdayFrom,
  // setAddedIndexesdayTo,
  // setAddedIndexesmonthFrom,
  // setAddedIndexesmonthTo,
  setMainPeriodOfTime,
  setMainShortTermMonitoring,
  setMainSummerizeOption,
  setMainTemporalMethod,
  // setSelectedDayFrom,
  // setSelectedDayTo,
  // setSelectedMonthFrom,
  // setSelectedMonthTo,
  setSelectedYearFrom,
  setSelectedYearTo,
  // setmainDerivative,
  // setmainFilter,
  setmainFilterToggle,
  setmainOrder,
  setmainWindowSize,
  setSelectedFromDate,
  setAddedIndexesFromDate,
  setAddedIndexesToDate,
  setSelectedToDate,
  clearSelectedDates,
} from "../../reducers/MaskingSlice";
// import MonthDayRangePickerByIndex from "../Prediction/MonthDayRangePickerByIndex";
// import CustomYearsPickerByIndex from "../Prediction/CustomYearPickerByIndex";
import CustomCheckBox from "./CustomCheckBox";
import YearPickerNormal from "./YearPickerNormal";
import { DateRangePicker } from 'react-date-range'; // Import react-date-range
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Popover } from '@mui/material';
import { formatDateDisplay } from "../../utils/date";

const HistoricalData = ({ mainIndex, indexes }) => {
  // const { t } = useTranslation();
  const dispatch = useDispatch();

  // Add state for date picker popovers
  const [datePickerAnchorEl, setDatePickerAnchorEl] = useState(null);
  const [addedIndexPickerAnchors, setAddedIndexPickerAnchors] = useState([]);
  const selectedFromDate = useSelector(
    (state) => state.maskingState.selectedFromDate
  );
  const selectedToDate = useSelector(
    (state) => state.maskingState.selectedToDate
  )
  
  // Helper function to validate date strings
  const isValidDate = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  };
  
  // Helper function to restrict date selection to available range
  const allowedRange = (minDate, maxDate) => (date) => {
    if (!minDate || !maxDate) return false;
    const current = new Date(date);
    return current < minDate || current > maxDate;
  };
  
  const datePickerOpen = Boolean(datePickerAnchorEl);
  const datePickerId = datePickerOpen ? 'date-range-popover' : undefined;

  const formatRangeForPicker = (fromDate, toDate, indexName = null) => {
    let startDate, endDate;
    
    if (fromDate && toDate) {
      // If both dates are selected, use them
      startDate = new Date(fromDate);
      endDate = new Date(toDate);
    } else {
      // If no dates selected, use the available range for the index
      const availableRange = getDateRange(indexName || mainIndex);
      if (availableRange.length === 2) {
        // CHANGE: Use the last available date (toDate) instead of first
        startDate = availableRange[1]; // Use the last available date
        endDate = availableRange[1];   // Set both to last date initially
      } else {
        // Fallback to current date if no range available
        const currentDate = new Date();
        startDate = currentDate;
        endDate = currentDate;
      }
    }

    return [{
      startDate: startDate,
      endDate: endDate,
      key: 'selection'
    }];
  };

  const formatDisplayDateRange = (fromDate, toDate) => {
    if (fromDate && toDate) {
      const startDate = new Date(fromDate);
      const endDate = new Date(toDate);
      const startStr = formatDateDisplay(startDate);
      const endStr = formatDateDisplay(endDate);
      return startDate.getTime() === endDate.getTime() ? startStr : `${startStr} - ${endStr}`;
    }
    return "Select Date Range";
  };

  const handleDatePickerClick = (event) => {
    setDatePickerAnchorEl(event.currentTarget);
  };

  const handleDatePickerClose = () => {
    setDatePickerAnchorEl(null);
  };

  // Handle date range change
  const handleRangeChange = (item) => {
    const selectionKey = Object.keys(item)[0];
    const range = item[selectionKey];

    if (!range || !range.startDate || !range.endDate) {
      return;
    }

    const jsStartDate = new Date(range.startDate);
    const jsEndDate = new Date(range.endDate);

    jsStartDate.setHours(12, 0, 0, 0);
    jsEndDate.setHours(12, 0, 0, 0);

    dispatch(setSelectedFromDate(jsStartDate.toISOString().split("T")[0]));
    dispatch(setSelectedToDate(jsEndDate.toISOString().split("T")[0]));
  };

  const mainSummerizeOption = useSelector(
    (state) => state.maskingState.mainSummerizeOption
  );
  const mainTemporalMethod = useSelector(
    (state) => state.maskingState.mainTemporalMethod
  );

  const mainPeriodOfTime = useSelector(
    (state) => state.maskingState.mainPeriodOfTime
  );

  const currentIndexId = localStorage.getItem('currentIndexId');

  // const monthFrom = useSelector(
  //   (state) => state.maskingState.selectedMonthFrom
  // );
  // const monthTo = useSelector((state) => state.maskingState.selectedMonthTo);
  // const dayFrom = useSelector((state) => state.maskingState.selectedDayFrom);
  // const dayTo = useSelector((state) => state.maskingState.selectedDayTo);
  const yearFrom = useSelector((state) => state.maskingState.selectedYearFrom);
  const yearTo = useSelector((state) => state.maskingState.selectedYearTo);
  const addedIndexes = useSelector((state) => state.maskingState.addedIndexes);

  // Added getDateRange function (similar to Prediction/MainIndex.jsx)
  const getDateRange = (indexName) => {
    if (!indexName) return [];
    try {
      const categories = JSON.parse(localStorage.getItem("categories")) || [];
      const currentIndex = categories.find((category) => category.name.toLowerCase() === indexName.toLowerCase());
      if (currentIndex && currentIndex.available_from && currentIndex.available_to && (currentIndex.available_from !== "None" && currentIndex.available_to !== "None")) {
        // Return dates without time
        const fromDate = new Date(currentIndex.available_from);
        const toDate = new Date(currentIndex.available_to);
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(0, 0, 0, 0);
        return [fromDate, toDate];
      }
    } catch (error) {
      console.error("Error parsing categories from localStorage:", error);
    }
    return []; // Return empty array if not found or error occurs
  };

  // Helper function to get default date range for added indexes
  const getDefaultDateRange = (indexName) => {
    const dateRange = getDateRange(indexName);
    if (dateRange.length === 2) {
      return {
        // CHANGE: Use the last available date (toDate) as default instead of first
        startDate: dateRange[1], // Use available to date as start
        endDate: dateRange[1]    // Use available to date as end
      };
    }
    // Fallback to current date if no range available
    const currentDate = new Date();
    return {
      startDate: currentDate,
      endDate: currentDate
    };
  };

  const pageTitle = mainIndex.toUpperCase();
  const handleAddIndex = () => {
    if (addedIndexes.length > 0) {
      // Get the first index's data
      const firstIndex = addedIndexes[0];

      // Initialize new index
      dispatch(setAddedIndexesInit());

      // Get the new index number
      const newIndex = addedIndexes.length;

      // Copy some data from first index but NOT the name/id
      if (firstIndex.filterToggle) {
        dispatch(setAddedIndexesFilterToggle({ index: newIndex }));
        dispatch(setAddedIndexesWindow({ index: newIndex, window: firstIndex.window || 10 }));
        dispatch(setAddedIndexesOrder({ index: newIndex, order: firstIndex.order || 2 }));
      }

      if (firstIndex.periodOfTime) {
        dispatch(setAddedIndexesPeriodOfTime({
          index: newIndex,
          index2: newIndex,
          periodOfTime: firstIndex.periodOfTime
        }));
      }

      if (firstIndex.temporalMethod) {
        dispatch(setAddedIndexesTemporalMethod({
          index: newIndex,
          index2: newIndex,
          temporalMethod: firstIndex.temporalMethod
        }));
      }

      if (firstIndex.summerizeOptions) {
        dispatch(setAddedIndexesSummerizeOptions({
          index: newIndex,
          index2: newIndex,
          summerizeOptions: firstIndex.summerizeOptions
        }));
      }

      // CHANGE: Copy date range and short term from first index if they have values
      if (firstIndex.from_date) {
        dispatch(setAddedIndexesFromDate({
          index: newIndex,
          fromDate: firstIndex.from_date
        }));
      }

      if (firstIndex.to_date) {
        dispatch(setAddedIndexesToDate({
          index: newIndex,
          toDate: firstIndex.to_date
        }));
      }

      if (firstIndex.yearFrom) {
        dispatch(setAddedIndexesYearFrom({
          index: newIndex,
          yearFrom: firstIndex.yearFrom
        }));
      }

      if (firstIndex.yearTo) {
        dispatch(setAddedIndexesYearTo({
          index: newIndex,
          yearTo: firstIndex.yearTo
        }));
      }

      if (firstIndex.shortTermMonitoring) {
        dispatch(setAddedIndexesShortTerm({
          index: newIndex,
          short: firstIndex.shortTermMonitoring
        }));
      }

      // DO NOT copy name, id - let user select fresh
    } else {
      dispatch(setAddedIndexesInit());
    }
  };
  
  const mainFilterToggle = useSelector(
    (state) => state.maskingState.mainFilterToggle
  );
  // const datePickerTimeFrom = useSelector(
  //   (state) => state.mapState.date.datePickerTimeFrom
  // );
  // const datePickerTimeTo = useSelector(
  //   (state) => state.mapState.date.datePickerTimeTo
  // );
  // const mainFilter = useSelector((state) => state.maskingState.mainFilter);
  const mainWindowSize = useSelector(
    (state) => state.maskingState.mainWindowSize
  );
  // const mainDerivative = useSelector(
  //   (state) => state.maskingState.mainDerivative
  // );
  const mainOrder = useSelector((state) => state.maskingState.mainOrder);

  const handleToggleMainFilter = () => {
    dispatch(setmainFilterToggle());
  };

  const handleToggleFilter = (index) => {
    dispatch(setAddedIndexesFilterToggle({ index: index }));
  };
  
  const handleDateRangeChange = (addedIndex, date) => {
    if (date && date.length === 2) {
      if (mainIndex === "all" || mainIndex === "reporting") {
        // dispatch(setAddedIndexesId({ index: addedIndex, id: currentIndexId }));
        dispatch(setAddedIndexesYearFrom({ index: addedIndex, yearFrom: new Date(date[0]).getFullYear() }));
        dispatch(setAddedIndexesYearTo({ index: addedIndex, yearTo: new Date(date[1]).getFullYear() }));
        dispatch(setSelectedYearFrom(new Date(date[0]).getFullYear()));
        dispatch(setSelectedYearTo(new Date(date[1]).getFullYear()));
        console.log("ADDED INDEX YEAR FROM: ", new Date(date[0]).getFullYear(), "ADDED INDEX YEAR TO: ", new Date(date[1]).getFullYear())
      } else {
        dispatch(setSelectedYearFrom(new Date(date[0]).getFullYear()));
        dispatch(setSelectedYearTo(new Date(date[1]).getFullYear()));
        console.log("YEAR FROM: ", new Date(date[0]).getFullYear(), "YEAR TO: ", new Date(date[1]).getFullYear())
      }
      console.log("year from", yearFrom)
      console.log("year to", yearTo)
    }
  };
  
  return (
    <div style={{ width: "60%" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {mainIndex !== "all" && mainIndex !== "reporting" && <Typography fontWeight={500} fontSize={30}>
          {pageTitle}
        </Typography>}
        {mainIndex === "reporting" && <Typography fontWeight={500} fontSize={30}>
          Reporting
        </Typography>}
        {mainIndex === "all" && <Typography fontWeight={500} fontSize={30}>
          Monitoring
        </Typography>}
      </div>
      <br />
      {mainIndex !== "all" && mainIndex !== "reporting" && <div style={{ width: "100%" }}>
        <div>
          <FormControlLabel
            control={
              <Switch
                checked={mainFilterToggle}
                onChange={() => handleToggleMainFilter()}
                color="primary"
              />
            }
            label="Filtering"
          />
          {mainFilterToggle && (
            <div>
              <br />
              <label>Days (minimum 3)</label>
              <br />
              <TextField
                fullWidth
                value={mainWindowSize || 10} 
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  if (value >= 3) {
                    dispatch(setmainWindowSize(parseInt(event.target.value))); 
                  }
                }}
                size="small"
                type="number"
                inputProps={{ min: 3 }}
              />
              <br />
              <br />
              <label>Order (minimum 1, must be less than days)</label>
              <br />
              <TextField
                fullWidth
                value={mainOrder || 2} 
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  const windowValue = parseInt(mainWindowSize) || 10;
                  if (value >= 1 && value < windowValue) {
                    dispatch(setmainOrder(parseInt(event.target.value))); 
                  }
                }}
                size="small"
                type="number"
                inputProps={{ min: 1, max: (parseInt(mainWindowSize) || 10) - 1 }}
              />
            </div>
          )}
        </div>
        <br />
        <div>
          <Typography>Select Range</Typography>
          <TextField
          variant="outlined"
          fullWidth
          size="small"
          margin="normal"
          aria-describedby={datePickerId}
          value={formatDisplayDateRange(selectedFromDate, selectedToDate)}
          onClick={handleDatePickerClick}
          InputProps={{
            readOnly: true,
          }}
          placeholder={`Select date range (${getDateRange(mainIndex)[0] ? formatDateDisplay(getDateRange(mainIndex)[0]) : 'N/A'} - ${getDateRange(mainIndex)[1] ? formatDateDisplay(getDateRange(mainIndex)[1]) : 'N/A'})`}
        />
        <Popover
          id={datePickerId}
          open={datePickerOpen}
          anchorEl={datePickerAnchorEl}
          onClose={handleDatePickerClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <DateRangePicker
            staticRanges={[]}
            ranges={formatRangeForPicker(selectedFromDate, selectedToDate, mainIndex)}
            onChange={handleRangeChange}
            shouldDisableDate={allowedRange(getDateRange(mainIndex)[0], getDateRange(mainIndex)[1])}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={1}
            direction="horizontal"
            editableDateInputs={false}
            minDate={getDateRange(mainIndex)[0] || undefined}
            maxDate={getDateRange(mainIndex)[1] || undefined}
          />
        </Popover>
        </div>
        <br />
        <div>
          <CustomCheckBox
            title={"Time-step"}
            data={mainPeriodOfTime}
            dispatch={dispatch}
            reduxFunc={setMainPeriodOfTime}
          />
          <br />
          <CustomCheckBox
            title={"Temporal Method"}
            data={mainTemporalMethod}
            dispatch={dispatch}
            reduxFunc={setMainTemporalMethod}
          />
          <br />
          <CustomCheckBox
            title={
              mainTemporalMethod.find(
                (option) => option.key === "pixel" && option.checked
              )
                ? "Spatial Stat"
                : "Temporal Stat"
            }
            data={mainSummerizeOption}
            dispatch={dispatch}
            reduxFunc={setMainSummerizeOption}
          />
          <br />
          <div style={{ width: "100%" }}>
            <Typography>Select Years Range</Typography>
            <br />
            <div style={{ display: "flex", gap: "4%" }}>
              <div style={{ width: "48%" }}>
                <YearPickerNormal
                  style={{ width: "100%" }}
                  addedIndex={null}
                  setYear={(value) => {
                    dispatch(setSelectedYearFrom(value));
                  }}
                  yearFrom={1900}
                  yearTo={new Date().getFullYear()}
                  label="Year From"
                  value={yearFrom}
                />
              </div>
              <div style={{ width: "48%" }}>
                <YearPickerNormal
                  style={{ width: "100%" }}
                  addedIndex={null}
                  setYear={(value) => {
                    dispatch(setSelectedYearTo(value));
                  }}
                  yearFrom={1900}
                  yearTo={new Date().getFullYear()}
                  label="Year To"
                  value={yearTo}
                />
              </div>
            </div>
          </div>
          <br />
          <div style={{ width: "100%" }}>
            <Typography fontWeight={500} fontSize={22}>Short Term Monitoring</Typography>
            <br />
            <Typography>Select Year (should be within historical years range)</Typography>
            <div style={{ width: "100%" }}>
              <YearPickerNormal
                style={{ width: "100%" }}
                addedIndex={null}
                setYear={(value) => dispatch(setMainShortTermMonitoring(value))}
                yearFrom={yearFrom || 1900}
                yearTo={yearTo || new Date().getFullYear()}
              />
            </div>

            <br />
            <br />
          </div>

        </div>
      </div>}

      {/* all indexes monitoring index */}
      {(mainIndex === "all" || mainIndex === "reporting") && <div>
        {addedIndexes.map((added, addedIndex) => {
          const defaultRange = getDefaultDateRange(added.name);
          
          return (
            <div key={addedIndex}>
              {addedIndex > 0 && (
                <Divider sx={{ marginY: '30px', '&::before, &::after': { borderColor: 'rgba(0, 0, 0, 0.2)' } }} />
              )}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight={600}>Choose Index</Typography>
              </div>
              <br />
              <Autocomplete
                size="small"
                disablePortal
                id="combo-box-demo"
                isOptionEqualToValue={(option, value) =>
                  option.name === value.name
                }
                getOptionLabel={(option) => (option ? option.name : "")}
                onChange={(event, selected) => {
                  if (selected) {
                    console.log("selected", selected);
                    dispatch(setAddedIndexesId({ index: addedIndex, id: selected.id }));
                    dispatch(
                      setAddedIndexesName({
                        index: addedIndex,
                        name: selected.key,
                      })
                    );
                  }
                }}
                options={indexes || []}
                sx={{ width: "100%" }}
                renderInput={(params) => (
                  <TextField {...params} label="Index" required />
                )}
                value={added.name ? indexes.find(idx => idx.key === added.name) || null : null}
              />
              <br />
              <div>
                <>
                  <div>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={added.filterToggle ?? (addedIndexes[0]?.filterToggle || false)}
                          onChange={() => handleToggleFilter(addedIndex)}
                          color="primary"
                        />
                      }
                      label="Do you want to use Filtering ?"
                    />
                    <br />
                    {added.filterToggle && (
                      <div>
                        <label>Days (minimum 3)</label>
                        <br />

                        <TextField
                          onChange={(event) => {
                            const value = parseInt(event.target.value);
                            if (value >= 3) {
                            dispatch(
                              setAddedIndexesWindow({
                                index: addedIndex,
                                  window: event.target.value,
                              })
                            );
                            }
                          }}
                          size="small"
                          value={added.window || 10}
                          type="number"
                          inputProps={{ min: 3 }}
                        />
                        <br />
                        <br />
                        <label>Order (minimum 1, must be less than days)</label>
                        <br />

                        <TextField
                          onChange={(event) => {
                            const value = parseInt(event.target.value);
                            const windowValue = parseInt(added.window) || 10;
                            if (value >= 1 && value < windowValue) {
                            dispatch(
                              setAddedIndexesOrder({
                                index: addedIndex,
                                  order: event.target.value,
                              })
                            );
                            }
                          }}
                          size="small"
                          value={added.order || 2}
                          type="number"
                          inputProps={{ min: 1, max: (parseInt(added.window) || 10) - 1 }}
                        />
                      </div>
                    )}
                    <br />
                  </div>
                  <div>
                    <Typography>Select Range</Typography>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="normal"
                      disabled={!added.name || getDateRange(added.name).length === 0}
                      value={formatDisplayDateRange(added.from_date, added.to_date)}
                      onClick={(event) => {
                        if (added.name) {
                          const newAnchors = [...addedIndexPickerAnchors];
                          newAnchors[addedIndex] = event.currentTarget;
                          setAddedIndexPickerAnchors(newAnchors);
                        }
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      placeholder={added.name && getDateRange(added.name).length > 0 ?
                        `Available: ${formatDateDisplay(getDateRange(added.name)[0])} - ${formatDateDisplay(getDateRange(added.name)[1])}` :
                        "Select an index first"
                      }
                    />
                    <Popover
                      open={Boolean(addedIndexPickerAnchors[addedIndex])}
                      anchorEl={addedIndexPickerAnchors[addedIndex]}
                      onClose={() => {
                        const newAnchors = [...addedIndexPickerAnchors];
                        newAnchors[addedIndex] = null;
                        setAddedIndexPickerAnchors(newAnchors);
                      }}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <DateRangePicker
                        staticRanges={[]}
                        ranges={[{
                          startDate: added.from_date ? new Date(added.from_date) : defaultRange.startDate,
                          endDate: added.to_date ? new Date(added.to_date) : defaultRange.endDate,
                          key: 'selection'
                        }]}
                        onChange={(item) => {
                          if (!item.selection || !item.selection.startDate || !item.selection.endDate) {
                            return;
                          }
                          
                          const fromDate = new Date(item.selection.startDate);
                          const toDate = new Date(item.selection.endDate);
                          
                          fromDate.setHours(12, 0, 0, 0);
                          toDate.setHours(12, 0, 0, 0);
                          
                          dispatch(
                            setAddedIndexesFromDate({
                              index: addedIndex,
                              fromDate: fromDate.toISOString().split("T")[0]
                            })
                          );
                          
                          dispatch(
                            setAddedIndexesToDate({
                              index: addedIndex,
                              toDate: toDate.toISOString().split("T")[0]
                            })
                          );
                        }}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={1}
                        direction="horizontal"
                        editableDateInputs={false}
                        minDate={getDateRange(added.name)[0] || undefined}
                        maxDate={getDateRange(added.name)[1] || undefined}
                      />
                    </Popover>
                    {!added.name && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginTop: '4px' }}>
                        Please select an index first to enable date selection.
                      </Typography>
                    )}
                  </div>
                </>
                <br />
                <div>
                  <CustomCheckBox
                    title={"Time-step"}
                    data={added.periodOfTime}
                    dispatch={dispatch}
                    reduxFunc={setAddedIndexesPeriodOfTime}
                    index={addedIndex}
                  />
                  <br />
                  <CustomCheckBox
                    title={"Temporal Method"}
                    data={added.temporalMethod}
                    dispatch={dispatch}
                    reduxFunc={setAddedIndexesTemporalMethod}
                    index={addedIndex}
                  />
                  <br />
                  <CustomCheckBox
                    title={
                      (added.temporalMethod?.find(
                        (option) => option.key === "pixel" && option.checked
                      ))
                        ? "Spatial Stats"
                        : "Temporal Stats"
                    }
                    data={added.summerizeOptions}
                    dispatch={dispatch}
                    reduxFunc={setAddedIndexesSummerizeOptions}
                    index={addedIndex}
                  />
                  <br />
                  <div style={{ width: "100%" }}>
                    <Typography>Select Historical Years</Typography>
                    <br />
                    <div style={{ display: "flex", gap: "4%" }}>
                      <div style={{ width: "48%" }}>
                        <YearPickerNormal
                          style={{ width: "100%" }}
                          setYear={(value) => dispatch(setAddedIndexesYearFrom({ index: addedIndex, yearFrom: value }))}
                          yearFrom={1900}
                          yearTo={new Date().getFullYear()}
                          label="Year From"
                          defValue={added.yearFrom}
                        />
                      </div>
                      <div style={{ width: "48%" }}>
                        <YearPickerNormal
                          style={{ width: "100%" }}
                          setYear={(value) => dispatch(setAddedIndexesYearTo({ index: addedIndex, yearTo: value }))}
                          yearFrom={1900}
                          yearTo={new Date().getFullYear()}
                          label="Year To"
                          defValue={added.yearTo}
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div style={{ width: "100%" }}>
                    <Typography>Select Short-term Year (should be within historical years range)</Typography>
                    <br />
                    <div style={{ width: "100%" }}>
                      <YearPickerNormal
                        style={{ width: "100%" }}
                        setYear={(value) => dispatch(setAddedIndexesShortTerm({ index: addedIndex, short: value }))}
                        yearFrom={added.yearFrom || 1900}
                        yearTo={added.yearTo || new Date().getFullYear()}
                        defValue={added.shortTermMonitoring}
                      />
                    </div>

                    <br />
                    <br />
                  </div>

                </div>
              </div>
              <br />
              <Button
                variant="outlined"
                color="error"
                onClick={() => {
                  dispatch(deleteOneAddIndex({ index: addedIndex }));
                }}
              >
                Delete this index
              </Button>
              <br />
              <br />
            </div>
          );
        })}
        <Button fullWidth variant="outlined" onClick={handleAddIndex}>
          {addedIndexes.length > 0 ? "Add another index" : "Add Index"}
        </Button>
      </div>}
    </div >
  );
};

export default HistoricalData;